import { Stack } from "@fluentui/react";

interface FilterTotalsComponentProps {
  /**
   * String representing the type of items being displayed.
   * - would be the text saying showing x {itemType}s in the filtered text
   * - defaults to "experiment" if not provided
   */
  itemType?: string;
  /**
   * The total count of items before any filters are applied.
   */
  totalItemsCount: number;
  /**
   * The number of items after filters are applied.
   */
  filteredItemsCount: number;
  /**
   * The applied filters, used to get the total number of filters applied
   * - would be the text saying (x filters applied) in the filtered text
   */
  appliedFilters: Record<string, any>;
  /**
   * Applied search string to include in the filter text
   *   - will show Showing x {itemType}s for search "{searchString}"
   */
  searchString?: string;
}

/**
 * FilterTotalsComponent displays the total count of items and how many are currently shown after filtering,
 * along with the count of applied filters.
 */
const FilterTotalsComponent: React.FC<FilterTotalsComponentProps> = ({
  itemType = "experiment",
  totalItemsCount,
  filteredItemsCount,
  appliedFilters,
  searchString,
}) => {
  const pluralizedItemType = totalItemsCount === 1 ? itemType : `${itemType}s`;
  const appliedFilterCount = Object.keys(appliedFilters).length;
  const pluralizedFilterText = appliedFilterCount === 1 ? "filter" : "filters";
  return (
    <Stack horizontalAlign="start">
      Showing {filteredItemsCount}
      {filteredItemsCount !== totalItemsCount ? ` of ${totalItemsCount} ` : " "}
      {pluralizedItemType}
      {searchString ? ` for search "${searchString}"` : ""}
      {appliedFilterCount > 0
        ? ` with ${appliedFilterCount} ${pluralizedFilterText} applied`
        : ""}
      .
    </Stack>
  );
};

export default FilterTotalsComponent;
